//Price Universal Base Plan
export const PRICE_BASE_UNIVERSAL_STARTER_MONTHLY = 77.0;
export const PRICE_BASE_UNIVERSAL_STARTER_ANNUAL = 739.2;

export const PRICE_BASE_UNIVERSAL_MASTER_MONTHLY = 97.0;
export const PRICE_BASE_UNIVERSAL_MASTER_ANNUAL = 931.2;

export const PRICE_BASE_UNIVERSAL_ULTIMATE_MONTHLY = 117.0;
export const PRICE_BASE_UNIVERSAL_ULTIMATE_ANNUAL = 1123.2;

// Price Universal JusProcessos Plan até 50 processos
export const PRICE_JP_50_UNIVERSAL_STARTER_MONTHLY = 101.9;
export const PRICE_JP_50_UNIVERSAL_STARTER_ANNUAL = 1038.0;

export const PRICE_JP_50_UNIVERSAL_MASTER_MONTHLY = 121.9;
export const PRICE_JP_50_UNIVERSAL_MASTER_ANNUAL = 1230.0;

export const PRICE_JP_50_UNIVERSAL_ULTIMATE_MONTHLY = 141.9;
export const PRICE_JP_50_UNIVERSAL_ULTIMATE_ANNUAL = 1422.0;

// Price Universal Jusprocessos 200 process

export const PRICE_JP_200_UNIVERSAL_STARTER_MONTHLY = 176.9;
export const PRICE_JP_200_UNIVERSAL_STARTER_ANNUAL = 1938.0;

export const PRICE_JP_200_UNIVERSAL_MASTER_MONTHLY = 196.9;
export const PRICE_JP_200_UNIVERSAL_MASTER_ANNUAL = 2130.0;

export const PRICE_JP_200_UNIVERSAL_ULTIMATE_MONTHLY = 216.9;
export const PRICE_JP_200_UNIVERSAL_ULTIMATE_ANNUAL = 2322.0;

//Price Universal JUsprocessos 500 ṕrocess

export const PRICE_JP_500_UNIVERSAL_STARTER_MONTHLY = 326.9;
export const PRICE_JP_500_UNIVERSAL_STARTER_ANNUAL = 3738.0;

export const PRICE_JP_500_UNIVERSAL_MASTER_MONTHLY = 346.9;
export const PRICE_JP_500_UNIVERSAL_MASTER_ANNUAL = 3930.0;

export const PRICE_JP_500_UNIVERSAL_ULTIMATE_MONTHLY = 366.9;
export const PRICE_JP_500_UNIVERSAL_ULTIMATE_ANNUAL = 4122.0;

export const PRICE_CAAMG_STARTER_MONTHLY = 53.9;
export const PRICE_CAAMG_STARTER_ANNUAL = 646.8;

export const PRICE_CAAMG_MASTER_MONTHLY = 67.9;
export const PRICE_CAAMG_MASTER_ANNUAL = 814.8;

export const PRICE_CAAMG_ULTIMATE_MONTHLY = 81.9;
export const PRICE_CAAMG_ULTIMATE_ANNUAL = 982.8;